import React from "react";
import Isvg from "../../../vendor/react-inlinesvg";

class progressArc extends React.Component {
  _buildPathData() {
    const currentProgress = this.props.showProgress;

    if (!this.props.reviewComplete) {
      return Fraction.Helpers.Calc.describeArc(
        31,
        31,
        22,
        0,
        Math.min(359.999, (360 * currentProgress) / 100)
      );
    } else {
      return Fraction.Helpers.Calc.describeArc(
        62,
        62,
        45,
        0,
        Math.min(359.999, (360 * currentProgress) / 100)
      );
    }
  }

  _textualData() {
    if (this.props.numerator && this.props.denominator) {
      if (this.props.viewSummary) {
        return <Isvg src="/img/checkmark.svg" />;
      }
      return this.props.numerator + "/" + this.props.denominator;
    }
    let value;
    if (!this.props.showProgress) {
      value = null;
    } else if (this.props.finshed) {
      value = this.props.showProgress;
    } else {
      value = this.props.showProgress + "%";
    }
    return value;
  }

  render() {
    let strokeWidth = this.props.reviewComplete ? 10 : 12;
    return (
      <div
        className="progress noButton"
        data-menu-id="review-mode-progress-menu"
        aria-expanded="false"
        aria-disabled={this.props.reviewComplete}
      >
        <span className="offScreen">
          {i18n.t("review-mode.progress-button")}
        </span>
        <div className="progress-ring">
          <svg className="progress-ring-arc">
            <path
              id={this.props.id || "arc1"}
              fill={this.props.id || "none"}
              stroke={this.props.strokeColor || "#eb710b"}
              strokeWidth={strokeWidth}
              d={this.props.showProgress && this._buildPathData()}
            />
          </svg>
          <div className="inner-progress">{this._textualData()}</div>
        </div>
      </div>
    );
  }
}
export default progressArc;
